import { render, staticRenderFns } from "./LugarInteresModalNuevo.vue?vue&type=template&id=efc7a96e&scoped=true&"
import script from "./LugarInteresModalNuevo.vue?vue&type=script&lang=ts&"
export * from "./LugarInteresModalNuevo.vue?vue&type=script&lang=ts&"
import style0 from "./LugarInteresModalNuevo.vue?vue&type=style&index=0&id=efc7a96e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc7a96e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('efc7a96e', component.options)
    } else {
      api.reload('efc7a96e', component.options)
    }
    module.hot.accept("./LugarInteresModalNuevo.vue?vue&type=template&id=efc7a96e&scoped=true&", function () {
      api.rerender('efc7a96e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/plataforma/LugarInteresModalNuevo.vue"
export default component.exports